"use strict";

exports.__esModule = true;
var _UpdateTicketWatcherRuleScreen = require("./UpdateTicketWatcherRuleScreen");
Object.keys(_UpdateTicketWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateTicketWatcherRuleScreen[key]) return;
  exports[key] = _UpdateTicketWatcherRuleScreen[key];
});